import { useState, useCallback } from 'react';
import { message } from 'antd';
import { pwg332Api, QueryParams, PaymentDetail } from '../../../services/pwg332Api';

export function usePWG332Query() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<PaymentDetail[]>([]);
  const [totalAmt, setTotalAmt] = useState<number>(0);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (params: QueryParams) => {
    if (!params.deliveryNo.trim()) {
      message.warning('請輸入交運單號');
      return;
    }
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await pwg332Api.query(params);
      if (resp.data && resp.data.length > 0) {
        setData(resp.data);
        setTotalAmt(resp.total_amt ?? 0);
        setNoData(false);
      } else {
        setData([]);
        setTotalAmt(0);
        setNoData(true);
        message.info('查無此資料!');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData([]);
    setTotalAmt(0);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, data, totalAmt, queried, noData, runQuery, reset };
}
